module.exports = __webpack_public_path__ + "static/img/logo-example-9.de67ef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-example-9.svg
// module id = YHac
// module chunks = 0